import styled from 'styled-components';
import {dFlexColumnCenter, dFlexColumn, dFlex, alignCenter, justifyCenter} from '../../../globalVariables/GlobalFlex';

export const content = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    ${justifyCenter}
    min-height: 100%;
    gap: var(--space-xl);
    padding: var(--space-xl) var(--space-lg);
    text-align: center;
`;

export const liveGroup = styled.div`
    ${dFlexColumnCenter};
    width: 100%;
    min-height: 9.5rem;
    justify-content: flex-start;
    gap: var(--space-md);
`;

export const thanks = styled.h2`
    font-size: var(--font-size-h2);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
`;

export const block = styled.div`
    ${dFlexColumnCenter};
    gap: var(--space-sm);
    width: 100%;
`;

export const blockLabel = styled.span`
    font-size: var(--font-size-label);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-default);
`;

export const producerLogo = styled.img`
    max-width: 60%;
    max-height: 66px;
    object-fit: contain;
`;

export const producerName = styled.span`
    font-size: var(--font-size-heading-page);
    font-weight: var(--font-weight-bold);
    line-height: 1.2;
    letter-spacing: 0.01em;
`;

export const liveLogo = styled.img`
    width: 150px;
    height: 28px;
    object-fit: contain;
`;

export const sep = styled.span`
    width: calc(100% - var(--space-lg));
    height: 1px;
    flex: none;
    background-image: repeating-linear-gradient(
        to right,
        var(--color-border-subtle) 0 1px,
        transparent 1px 4px
    );
`;

export const pills = styled.div`
    ${dFlex}
    ${justifyCenter}
    flex-wrap: wrap;
    gap: var(--space-sm);
    width: 100%;
`;

export const pill = styled.a`
    ${dFlex}
    ${alignCenter}
    min-height: 44px;
    gap: var(--space-sm);
    padding: 0 var(--space-lg);
    border: 1px solid var(--color-text-default);
    border-radius: 100px;
    color: var(--color-text-default);
    font-size: var(--font-size-body);
    font-weight: var(--font-weight-bold);
    text-decoration: none;
`;

export const avatar = styled.img`
    width: 36px;
    height: 36px;
    flex: none;
    border-radius: 50%;
    object-fit: cover;
    margin-inline-start: calc(var(--space-md) * -1);
`;
